<template>
  <div>
    <red-characters-header :title="page.template.header" :content="page.template.introductie"/>

    <main v-if="page.template.tekst" class="content container">
      <circle-img-content
        class="z-50 mt-0 lg:mt-40"
      >
        <div class="prose content" v-html="page.template.tekst"/>
      </circle-img-content>
    </main>

    <wave-content v-if="page.template.tekst_2" :header-text="page.template.header_2" text-only class="content">
      <div class="prose content" v-html="page.template.tekst_2"/>
    </wave-content>
  </div>
</template>

<script>
import RedCharactersHeader from '~/components/headers/RedCharactersHeader';
import CircleImgContent from '~/components/fullwidth-blocks/CircleImgContent';
import WaveContent from '~/components/fullwidth-blocks/WaveContent';
import page from '~/plugins/mixins/page';

export default {
  components: {WaveContent, CircleImgContent, RedCharactersHeader},
  mixins: [page],
};
</script>
